<template>
  <div>
    <div class="mt-[50px]">
      <div tabindex="0" class="e-card">
        <div class="e-card-image" :class="[isRight ? 'text-right' : 'text-left']">
          <!-- <span class="e-icons e-medium e-track"></span> -->
          <span class="material-icons"><i :class="cardIcon"></i></span>
          <div
            class="e-card-title font-bold"
            :class="[isRight ? 'bottomright' : 'bottomleft']"
          >
            {{ cardTitle }}
          </div>
        </div>
        <div class="e-card-content" :class="[isRight ? 'bottomright' : 'bottomleft']">
          {{ discription }}
        </div>
        <!-- <div class="e-card-header">
          <div class="e-card-header-caption">
            <div class="e-card-header-title">Laura Callahan</div>
            <div class="e-card-sub-title">
              Sales Coordinator and Representative
            </div>
          </div>
          <div class="e-card-header-image football"></div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  desc: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  right: {
    type: Boolean,
    default: true,
  },
});
const cardIcon = ref(props.icon);
const isRight = ref(props.right);

const { t } = useI18n();

const cardTitle = computed(() => t(props.title));
const discription = computed(() => t(props.desc));
</script>

<style>
.e-card {
  border: 2px solid transparent;
  padding: 1rem;
  border-radius: 10px;
  text-align: left;
  cursor: pointer;
  transition: 0.3s all;
  .material-icons {
    color: #b9b9b9;
  }
}

.e-card:hover {
  border: 2px solid var(--primary);
  background-color: white;
}

.e-card:hover .e-card-title {
  color: var(--primary);
}

.e-card:hover .material-icons {
  color: var(--primary);
}

.icon {
  font-size: 24px;
}

.e-icons.e-track:before {
  content: "\e8c9";
}

.e-card-image {
  min-height: 65px;
}

.e-card {
  width: 300px;
}

.bottomright {
  bottom: 0;
  right: 0;
  text-align: right;
}

.bottomleft {
  bottom: 0;
  right: 0;
  text-align: left;
}
</style>
